<div class="top-bar">
	<span class="logo"></span>
</div>